import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import "./styles/export.scss";
import "./assets/icon/iconfont.css";
import "./assets/font/font.css";
import "./utils/index";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/base.css";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import "@/utils/promission.js";
import Co_component from "./components/index";
import * as echarts from "echarts";
import "echarts-liquidfill";
import "./directive/dialog";
import constant from "./utils/constant";
import {Loading} from "_element-ui@2.15.14@element-ui";
import infiniteScroll from "vue-infinite-scroll";

Vue.use(infiniteScroll);
Vue.prototype.$echarts = echarts;
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.use(Co_component);

Vue.config.productionTip = false;
// 全局注册事件  监听session 变化
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'flag') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}
Vue.prototype.$constant = constant;
// 用于解决element el-radio报错问题 在el-radio-group标签上加上 v-removeAriaHidden
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});
// 添加全局方法，用于根据屏幕分辨率调整表格宽度
Vue.prototype.$elTableWidth = function(width) {
  // 判断当前分辨率
  if(window.screen.width >= 2160){
    // 在原有的基础上相加
    return Number(width) + 20;
  }else{
    return width;
  }
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
